/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.registerListeners = registerListeners;
exports.unregisterListeners = unregisterListeners;
function registerListeners(_ref) {
  var events = _ref.events,
    action = _ref.action;
  events.forEach(function (eventName) {
    if (eventName === 'mouseenter' || eventName === 'mouseleave' || eventName === 'scroll') {
      document.addEventListener(eventName, action, {
        capture: true
      });
    } else {
      document.addEventListener(eventName, action);
    }
  });
}
function unregisterListeners(_ref2) {
  var events = _ref2.events,
    action = _ref2.action;
  events.forEach(function (eventName) {
    if (eventName === 'mouseenter' || eventName === 'mouseleave' || eventName === 'scroll') {
      document.removeEventListener(eventName, action, {
        capture: true
      });
    } else {
      document.removeEventListener(eventName, action);
    }
  });
}